import {
  ICONS_LESSON_SUBSCRIPTION,
  ICONS_LESSON_VIEW,
  ICONS_QUIZ_ANSWER
} from '@constants/unacademyIcons/iconsEndpoints.constants';
import fetch from '@utils/api-helper/fetch';
import getUrl from '@utils/api-helper/getUrl';
import { HOST_TYPE } from '@utils/api-helper/host';
import { localStorageAvailable } from '@utils/localStorage';

class UAIconsAPI {
  static async confirmSubscription(getState, dispatch) {
    try {
      localStorage.removeItem('icons_sub_confirm_error');
      return fetch(ICONS_LESSON_SUBSCRIPTION, {
        useCamelCase: true,
        hasAppClient: true,
        getState,
        dispatch,
        requestType: 'POST',
        hostType: HOST_TYPE.UNACADEMY_ICONS
      });
    } catch (e) {
      if (localStorageAvailable()) {
        localStorage.setItem('icons_sub_confirm_error', `${e}`);
      }
    }
  }

  static async answerQuizQuestion(getState, dispatch, choice, timeTaken, uuid) {
    try {
      const requestUrl = getUrl({
        endpoint: ICONS_QUIZ_ANSWER,
        hostType: HOST_TYPE.UNACADEMY_ICONS,
        pathVars: { uuid },
        nextPreviewMode: false
      });
      return fetch(requestUrl, {
        useCamelCase: true,
        hasAppClient: true,
        getState,
        dispatch,
        requestType: 'POST',
        hostType: HOST_TYPE.UNACADEMY_ICONS,
        body: {
          choice,
          time_taken: timeTaken
        }
      })
        .then((res) => res)
        .catch(() => {
          return {};
        });
    } catch (e) {
      // TODO: return failed state
      if (localStorageAvailable()) {
        localStorage.setItem('icons_quiz_error', `${e}`);
      }
    }
  }

  static async sendLessonView(
    uuid,
    player,
    currentTime,
    currentDuration,
    getState,
    dispatch
  ) {
    const currentDateTime = new Date().toISOString();

    try {
      return fetch(ICONS_LESSON_VIEW, {
        useCamelCase: true,
        hasAppClient: true,
        getState,
        dispatch,
        requestType: 'POST',
        pathVars: { uuid },
        body: {
          current_duration: currentDuration,
          event_time: currentDateTime
        },
        hostType: HOST_TYPE.UNACADEMY_ICONS
      }).then(() => {
        if (localStorageAvailable()) {
          localStorage.setItem('lesson_view_logged', uuid);
          localStorage.setItem('lesson_duration', `${currentDuration}`);
          localStorage.removeItem('lesson_view_error');
        }
      });
    } catch (e) {
      if (localStorageAvailable()) {
        localStorage.setItem('lesson_view_error', `${e}`);
      }
    }
  }
}

export default UAIconsAPI;
